import { PreguntaExportador } from "../PreguntaExportador";
import { PreguntasTipoEnum } from "@shared/enums";

export class PreguntaMatrixMultipleExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.MATRIX_MULTIPLE;
    }
}
